<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
      <h1>KISS Sales Tools</h1>
      <br><br>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col
        v-for="card in cards"
        :key="card.id"
        class="d-flex child-flex"
        cols="12"
        sm="3"
      >
        <v-card>
          <v-img
          :src="card.src"
          :lazy-src="card.src"
          aspect-ratio="1"
          class="grey lighten-2"
          height="150px"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title>{{card.title}}</v-card-title>
          <v-card-actions>
            <v-btn
              color="orange"
              text
              :href="card.link"
              target="_blank"
            >
              View
            </v-btn>
            </v-card-actions>
        </v-card>
        <br>
      </v-col>
    </v-row>
    <br><br>
  
  </v-container>
</template>

<script>
export default {
  data: () => ({
    cards: [
      { 
        id: '1', 
        title: 'HERO Persaraan Anda !', 
        src: require('@/assets/img_sales_tool/ks-hero-persaraan-anda.png'),
        link: 'https://teraslegacy.com/wp-content/uploads/2024/02/KS-HERO-persaraan-anda.pdf', 
      },
      { 
        id: '2', 
        title: 'Safety Net Kewangan', 
        src: require('@/assets/img_sales_tool/ks-Safety-Net-Kewangan.jpeg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/Safety-Net-Kewangan.pdf', 
      },
      { 
        id: '3', 
        title: 'Property Legacy Rev 1.0', 
        src: require('@/assets/img_sales_tool/ks-Property-Legacy-Plan-Sales-Tool.jpg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/Property-Legacy-Plan-Sales-Tool-Rev.1.pdf',  
      },
      { 
        id: '4', 
        title: 'Income Protection Plan', 
        src: require('@/assets/img_sales_tool/ks-Income-Protection-Plan-Sales-Tool-pdf.jpeg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/Income-Protection-Plan-Sales-Tool.pdf', 
      },
      { 
        id: '5', 
        title: 'Hibah Pendapatan', 
        src: require('@/assets/img_sales_tool/ks-HIbah-Pendapatan-Sales-Tool-Rev-1-pdf.jpeg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/HIbah-Pendapatan-Sales-Tool-Rev-1.pdf',
      },
      { 
        id: '6', 
        title: '4 types of Saving Concept', 
        src: require('@/assets/img_sales_tool/ks-4-Types-Of-Saving-Concept-pdf.jpeg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/4-Types-Of-Saving-Concept.pdf',
      },
      { 
        id: '7', 
        title: '1st Module for New EA', 
        src: require('@/assets/img_sales_tool/entmod-1st-Module-for-New-EA.jpeg'),
        link: 'https://teraslegacy.com/wp-content/uploads/2021/12/1st-Module-for-New-EA-_-Make-it-Simple-_Concept-Presentation_.pdf', 
      },
    ],
  }),
}
</script>
